// extracted by mini-css-extract-plugin
export default {"result":"_f0e964bf","icon":"_e229f9d","title":"_4a641456","description":"_8f532fb0"};